import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IdDescription } from 'tms-lib';
import { BaseReferenceService } from './base';

// Allowance types are held PER PRODUCT TYPE, so the scoped call is the one to use - the
// unscoped get() would offer allowances belonging to yarn on a cloth fault.
@Injectable({
  providedIn: 'root',
})
export class AllowanceTypeReferenceService extends BaseReferenceService {
  constructor() {
    super('AllowanceTypeReference');
  }

  getForProductType(id: string): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(`${this.apiUrl}/GetForProductType/${id}`);
  }
}
